module.exports = __webpack_public_path__ + "static/img/5958_phase_function_Paper_PointsHejduk_Prediction.c0c2cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5958_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nnrv
// module chunks = 0